import React, {FC} from 'react';

import {isEmpty} from 'lodash';
import i18n from 'ui/i18n';

import CollapsableCard from '../CollapsableCard';
import QuestionStats from '../QuestionStats';

import {StatsProps} from './Stats.types';

const Stats: FC<StatsProps> = ({stats}) => {
    if (
        !stats.answers.count ||
        stats.questions.every((questionStats) => isEmpty(questionStats.stats))
    ) {
        return null;
    }

    return (
        <CollapsableCard title={i18n('success-page', 'stats-title')} uniqKey="stats">
            {stats.questions.map((questionStats) => (
                <QuestionStats stats={questionStats} key={questionStats.question.id} />
            ))}
        </CollapsableCard>
    );
};
export default Stats;
